import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class KomunikatyTabeliService {

  constructor(protected translate: TranslateService) { }

  get(): KomunikatyTabeli {
    return {
      emptyMessage: this.translate.instant('etykieta.brak-danych'),
      totalMessage: this.translate.instant('etykieta.razem'),
      selectedMessage: this.translate.instant('etykieta.zaznaczone'),
    };
  }

  getLiczbaWierszy(): (cells: any[]) => string {
    // return (cells: any[]) => `${cells.length} ${this.translate.instant('etykieta.razem')}`;
    return (cells: any[]) => `${this.translate.instant('etykieta.razem')}`;
  }
}

export interface KomunikatyTabeli {
  emptyMessage: string;
  totalMessage: string;
  selectedMessage: string;
}
